module.exports = __webpack_public_path__ + "img/21.cc4d8b95.jpg";